import { COUNTRY_PHONE_PATTERNS, FALLBACK_PHONE_PATTERN } from "../utils/phoneValidation";

/**
 * Gets the regex pattern for phone validation based on the country.
 * @param {string} countryName 
 * @returns {RegExp}
 */
export const getPhoneRegexForCountry = (countryName) => {
  if (!countryName) return FALLBACK_PHONE_PATTERN.regex;
  const match = COUNTRY_PHONE_PATTERNS[countryName];
  return match ? match.regex : FALLBACK_PHONE_PATTERN.regex;
};

/**
 * Gets the error message for phone validation based on the country.
 * @param {string} countryName 
 * @returns {string}
 */
export const getPhoneErrorMessageForCountry = (countryName) => {
  if (!countryName) return FALLBACK_PHONE_PATTERN.message;
  const match = COUNTRY_PHONE_PATTERNS[countryName];
  return match ? match.message : FALLBACK_PHONE_PATTERN.message;
};

/**
 * Gets the placeholder example value for phone number field based on the country.
 * @param {string} countryName 
 * @returns {string}
 */
export const getPhoneExampleForCountry = (countryName) => {
  if (!countryName) return FALLBACK_PHONE_PATTERN.example;
  const match = COUNTRY_PHONE_PATTERNS[countryName];
  return match ? match.example : FALLBACK_PHONE_PATTERN.example;
};
